import React, { useState, useEffect } from "/vendor/react";
import PropTypes from "prop-types";
import axios from "axios";
import { Card, CardContent, Typography, List } from "/vendor/@material-ui/core";
import {
    CheckStatusIcon,
    DetailedListItem,
    DetailedListItemTitle, DetailedListItemSubtitle,
} from "/lib/component/base";
import {makeStyles} from "@material-ui/core/styles";
import {Button} from "@material-ui/core"
import ServiceNowLogo from "../../../static/ServiceNow-logo.svg";

const useStyles = makeStyles({
    assetLink: {
        color: 'inherit',
        '&:hover': {
            textDecoration: 'underline',
        },
    }
});

const EntityAssets = ({ entity }) => {
    const [assetData, setAssetData] = useState({});
    const classes = useStyles()
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Basic ${Buffer.from('Integrationuser:.>4#wnT=(Y=hsMObyX>ojh*q__6cEk:M8N!oF?32').toString('base64')}`,
    }
    useEffect(() => {
        const fetchEntities = () => {
            axios.get("https://api.onewatch.hardware-inno.gcpprodau.tbm.sh/betmakers_terminal", {
                params: {
                    "terminalId": entity.name,
                },
                headers
            })
                .then((response) => {
                   setAssetData(response.data.result)
                })
                .catch((error) => {
                    console.error("Error fetching entities:", error);
                });
        };

        fetchEntities();
    }, [entity]);

    if (Object.keys(assetData).length === 0 || Object.keys(assetData)[0] === 'error') {
        return (
            <Card>
                <CardContent>
                    <Typography variant="h5" paragraph>
                        Assets - No Data Found
                    </Typography>
                </CardContent>
            </Card>
        )
    }

    const handleAssetSNow = () => {
      const url = assetData.url
      window.open(
        url,
        "parent",
        "popup",
      );
    }

    return (
        <Card>
            <CardContent>
                <Typography variant="h5" paragraph style={{ display: 'flex', flexDirection: 'row'}}>
                    Assets
                    <Button variant={"contained"} size={"small"} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: '10px'}} onClick={() => handleAssetSNow()}>
                      <span>View In</span>
                      <span style={{marginLeft: '5px'}}>
                        <img src={ServiceNowLogo} alt={"SNow Logo"} height={'15px'} />
                      </span>
                    </Button>
                </Typography>
                <List disablePadding>
                    <DetailedListItem>
                        <DetailedListItemTitle inset>
                            <Typography
                                component="span"
                                style={{ position: "absolute", left: 0 }}
                            >
                                <CheckStatusIcon
                                    statusCode={3}
                                    inline
                                    mutedOK
                                    small
                                    blockTooltip
                                />
                            </Typography>
                            <>
                                Teller Display Serial Number
                            </>
                        </DetailedListItemTitle>
                        <DetailedListItemSubtitle inset>
                            <>
                                {assetData.lcd_display_teller_ref.serial_number ? assetData.lcd_display_teller_ref.serial_number : "No Data"}
                            </>
                        </DetailedListItemSubtitle>
                    </DetailedListItem>
                    <DetailedListItem>
                        <DetailedListItemTitle inset>
                            <Typography
                                component="span"
                                style={{ position: "absolute", left: 0 }}
                            >
                                <CheckStatusIcon
                                    statusCode={3}
                                    inline
                                    mutedOK
                                    small
                                    blockTooltip
                                />
                            </Typography>
                            <>
                                Customer Display Serial Number
                            </>
                        </DetailedListItemTitle>
                        <DetailedListItemSubtitle inset>
                            <>
                                {assetData.lcd_customer_display.serial_number ? assetData.lcd_customer_display.serial_number : "No Data"}
                            </>
                        </DetailedListItemSubtitle>
                    </DetailedListItem>
                    <DetailedListItem>
                        <DetailedListItemTitle inset>
                            <Typography
                                component="span"
                                style={{ position: "absolute", left: 0 }}
                            >
                                <CheckStatusIcon
                                    statusCode={3}
                                    inline
                                    mutedOK
                                    small
                                    blockTooltip
                                />
                            </Typography>
                            <>
                                Teller Barcode Scanner
                            </>
                        </DetailedListItemTitle>
                        <DetailedListItemSubtitle inset>
                            <>
                                {assetData.lcd_display_teller_ref.barcode_reader_ref ? assetData.lcd_display_teller_ref.barcode_reader_ref : "No Data"}
                            </>
                        </DetailedListItemSubtitle>
                    </DetailedListItem>
                    <DetailedListItem>
                        <DetailedListItemTitle inset>
                            <Typography
                                component="span"
                                style={{ position: "absolute", left: 0 }}
                            >
                                <CheckStatusIcon
                                    statusCode={3}
                                    inline
                                    mutedOK
                                    small
                                    blockTooltip
                                />
                            </Typography>
                            <>
                                Customer Barcode Scanner
                            </>
                        </DetailedListItemTitle>
                        <DetailedListItemSubtitle inset>
                            <>
                                {assetData.lcd_customer_display.barcode_reader_ref ? assetData.lcd_customer_display.barcode_reader_ref : "No Data"}
                            </>
                        </DetailedListItemSubtitle>
                    </DetailedListItem>
                    <DetailedListItem>
                        <DetailedListItemTitle inset>
                            <Typography
                                component="span"
                                style={{ position: "absolute", left: 0 }}
                            >
                                <CheckStatusIcon
                                    statusCode={3}
                                    inline
                                    mutedOK
                                    small
                                    blockTooltip
                                />
                            </Typography>
                            <>
                                Teller Card Reader
                            </>
                        </DetailedListItemTitle>
                        <DetailedListItemSubtitle inset>
                            <>
                                {assetData.lcd_display_teller_ref.card_reader_ref ? assetData.lcd_display_teller_ref.card_reader_ref : "No Data"}
                            </>
                        </DetailedListItemSubtitle>
                    </DetailedListItem>
                    <DetailedListItem>
                        <DetailedListItemTitle inset>
                            <Typography
                                component="span"
                                style={{ position: "absolute", left: 0 }}
                            >
                                <CheckStatusIcon
                                    statusCode={3}
                                    inline
                                    mutedOK
                                    small
                                    blockTooltip
                                />
                            </Typography>
                            <>
                                Customer Card Reader
                            </>
                        </DetailedListItemTitle>
                        <DetailedListItemSubtitle inset>
                            <>
                                {assetData.lcd_customer_display.card_reader_ref ? assetData.lcd_customer_display.card_reader_ref : "No Data"}
                            </>
                        </DetailedListItemSubtitle>
                    </DetailedListItem>
                    <DetailedListItem>
                        <DetailedListItemTitle inset>
                            <Typography
                                component="span"
                                style={{ position: "absolute", left: 0 }}
                            >
                                <CheckStatusIcon
                                    statusCode={3}
                                    inline
                                    mutedOK
                                    small
                                    blockTooltip
                                />
                            </Typography>
                            <>
                                USB Hub
                            </>
                        </DetailedListItemTitle>
                        <DetailedListItemSubtitle inset>
                            <>
                                {assetData.usb_hub ? assetData.usb_hub : "No Data"}
                            </>
                        </DetailedListItemSubtitle>
                    </DetailedListItem>
                    <DetailedListItem>
                        <DetailedListItemTitle inset>
                            <Typography
                                component="span"
                                style={{ position: "absolute", left: 0 }}
                            >
                                <CheckStatusIcon
                                    statusCode={3}
                                    inline
                                    mutedOK
                                    small
                                    blockTooltip
                                />
                            </Typography>
                            <>
                                12v Power Supply
                            </>
                        </DetailedListItemTitle>
                        <DetailedListItemSubtitle inset>
                            <>
                                {assetData.pc_psu_ref["12v_power_supply_number"] ? assetData.pc_psu_ref["12v_power_supply_number"] : "No Data"}
                            </>
                        </DetailedListItemSubtitle>
                    </DetailedListItem>
                    <DetailedListItem>
                        <DetailedListItemTitle inset>
                            <Typography
                                component="span"
                                style={{ position: "absolute", left: 0 }}
                            >
                                <CheckStatusIcon
                                    statusCode={3}
                                    inline
                                    mutedOK
                                    small
                                    blockTooltip
                                />
                            </Typography>
                            <>
                                24v Power Supply
                            </>
                        </DetailedListItemTitle>
                        <DetailedListItemSubtitle inset>
                            <>
                                {assetData.pc_psu_ref["24v_power_supply_number"] ? assetData.pc_psu_ref["24v_power_supply_number"] : "No Data"}
                            </>
                        </DetailedListItemSubtitle>
                    </DetailedListItem>
                    <DetailedListItem>
                        <DetailedListItemTitle inset>
                            <Typography
                                component="span"
                                style={{ position: "absolute", left: 0 }}
                            >
                                <CheckStatusIcon
                                    statusCode={3}
                                    inline
                                    mutedOK
                                    small
                                    blockTooltip
                                />
                            </Typography>
                            <>
                                Printer
                            </>
                        </DetailedListItemTitle>
                        <DetailedListItemSubtitle inset>
                            <>
                                {assetData.custom_printer_ref.serial_number ? assetData.custom_printer_ref.serial_number : "No Data"}
                            </>
                        </DetailedListItemSubtitle>
                    </DetailedListItem>
                    <DetailedListItem>
                        <DetailedListItemTitle inset>
                            <Typography
                                component="span"
                                style={{ position: "absolute", left: 0 }}
                            >
                                <CheckStatusIcon
                                    statusCode={3}
                                    inline
                                    mutedOK
                                    small
                                    blockTooltip
                                />
                            </Typography>
                            <>
                                BNA Acceptor
                            </>
                        </DetailedListItemTitle>
                        <DetailedListItemSubtitle inset>
                            <>
                                {assetData.note_acceptor_ref.serial_number ? assetData.note_acceptor_ref.serial_number : "No Data"}
                            </>
                        </DetailedListItemSubtitle>
                    </DetailedListItem>
                    <DetailedListItem>
                        <DetailedListItemTitle inset>
                            <Typography
                                component="span"
                                style={{ position: "absolute", left: 0 }}
                            >
                                <CheckStatusIcon
                                    statusCode={3}
                                    inline
                                    mutedOK
                                    small
                                    blockTooltip
                                />
                            </Typography>
                            <>
                                NFC Reader
                            </>
                        </DetailedListItemTitle>
                        <DetailedListItemSubtitle inset>
                            <>
                                {assetData.nfc_reader_ref.serial_number ? assetData.nfc_reader_ref.serial_number : "No Data"}
                            </>
                        </DetailedListItemSubtitle>
                    </DetailedListItem>
                    <DetailedListItem>
                        <DetailedListItemTitle inset>
                            <Typography
                                component="span"
                                style={{ position: "absolute", left: 0 }}
                            >
                                <CheckStatusIcon
                                    statusCode={3}
                                    inline
                                    mutedOK
                                    small
                                    blockTooltip
                                />
                            </Typography>
                            <>
                                Serial Number
                            </>
                        </DetailedListItemTitle>
                        <DetailedListItemSubtitle inset>
                            <>
                                {assetData.serial_number ? assetData.serial_number : "No Data"}
                            </>
                        </DetailedListItemSubtitle>
                    </DetailedListItem>
                    <DetailedListItem>
                        <DetailedListItemTitle inset>
                            <Typography
                                component="span"
                                style={{ position: "absolute", left: 0 }}
                            >
                                <CheckStatusIcon
                                    statusCode={3}
                                    inline
                                    mutedOK
                                    small
                                    blockTooltip
                                />
                            </Typography>
                            <>
                                PC Serial Number
                            </>
                        </DetailedListItemTitle>
                        <DetailedListItemSubtitle inset>
                            <>
                                {assetData.pc_psu_ref.pc_serial_number ? assetData.pc_psu_ref.pc_serial_number : "No Data"}
                            </>
                        </DetailedListItemSubtitle>
                    </DetailedListItem>
                    <DetailedListItem>
                        <DetailedListItemTitle inset>
                            <Typography
                                component="span"
                                style={{ position: "absolute", left: 0 }}
                            >
                                <CheckStatusIcon
                                    statusCode={3}
                                    inline
                                    mutedOK
                                    small
                                    blockTooltip
                                />
                            </Typography>
                            <>
                                Name
                            </>
                        </DetailedListItemTitle>
                        <DetailedListItemSubtitle inset>
                            <>
                                {assetData.name ? assetData.name : "No Data"}
                            </>
                        </DetailedListItemSubtitle>
                    </DetailedListItem>
                    <DetailedListItem>
                        <DetailedListItemTitle inset>
                            <Typography
                                component="span"
                                style={{ position: "absolute", left: 0 }}
                            >
                                <CheckStatusIcon
                                    statusCode={3}
                                    inline
                                    mutedOK
                                    small
                                    blockTooltip
                                />
                            </Typography>
                            <>
                                OS License Number
                            </>
                        </DetailedListItemTitle>
                        <DetailedListItemSubtitle inset>
                            <>
                                {assetData.pc_psu_ref.os_license_number ? assetData.pc_psu_ref.os_license_number : "No Data"}
                            </>
                        </DetailedListItemSubtitle>
                    </DetailedListItem>
                </List>
            </CardContent>
        </Card>
    );
};

EntityAssets.propTypes = {
    entity: PropTypes.object.isRequired,
};

export default EntityAssets;
